<template>
  <div>
    <!--按客户导出-->
    <el-dialog
      :title="$t('mdfeTranslate.ExportByCustomer')"
      :visible.sync="showExportByCustomerWindow"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <div>
        <el-form
          ref="exportCustomerRef"
          :model="queryForm"
          label-position="top"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$t('GlobalSetObj.client')"
                prop="customerId"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change'] }
                ]"
              >
                <el-select
                  v-model="queryForm.customerId"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  :remote-method="getCustomerPage"
                  clearable
                  filterable
                  remote
                  reserve-keyword
                  style="width: 100%"
                  @visible-change="changeCustomerPage"
                >
                  <el-option
                    v-for="item in customerList"
                    :key="item.id"
                    :label="item.customerAlias + '（' + item.username + '）'"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('GlobalSetObj.InvoicingTime')"
                prop="invoiceIssueTime"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change'] }
                ]"
              >
                <el-date-picker
                  v-model="queryForm.invoiceIssueTime"
                  type="datetimerange"
                  range-separator="-"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  :start-placeholder="$t('GlobalSetObj.startDate')"
                  :end-placeholder="$t('GlobalSetObj.endDate')"
                  style="width: 100%;"
                  :picker-options="pickerOptions"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="clickExportByCustomer">{{ $t('collectionCenter.export') }}</el-button>
        <el-button size="small" @click="closeWindow">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiCustomerPage } from '@/api/customer';
import { exportCteInvoiceByCustomer } from '@/api/invoiceCenter';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'ExportByCustomer',
  props: {
    showExportByCustomer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const getSixMonthsAgo = () => {
      const now = new Date();
      const sixMonthsAgo = new Date(now);
      sixMonthsAgo.setMonth(now.getMonth() - 6);
      sixMonthsAgo.setHours(0, 0, 0, 0);
      return sixMonthsAgo.getTime();
    };
    return {
      queryForm: {
        customerId: null,
        invoiceIssueTime: []
      },
      customerList: [],
      showExportByCustomerWindow: false,
      pickerOptions: {
        disabledDate: (time) => {
          // 条件1：禁用当前日期 6 个月前的日期（永久生效）
          const sixMonthsAgoTime = getSixMonthsAgo();
          if (time.getTime() < sixMonthsAgoTime) {
            return true;
          }
          return false;
        },
        onPick: ({ minDate, maxDate }) => {
          // 当选中第一个日期时，叠加第二个限制条件
          if (minDate && !maxDate) {
            const sixMonthsAgoTime = getSixMonthsAgo();

            this.pickerOptions.disabledDate = (time) => {
              // 条件1：禁用当前日期 6 个月前的日期
              if (time.getTime() < sixMonthsAgoTime) {
                return true;
              }

              // 条件2：限制在第一个日期的前后 3 个月内
              const minTime = new Date(minDate);
              minTime.setMonth(minTime.getMonth() - 3);
              minTime.setHours(0, 0, 0, 0);

              const maxTime = new Date(minDate);
              maxTime.setMonth(maxTime.getMonth() + 3);
              maxTime.setHours(23, 59, 59, 999);

              if (time.getTime() < minTime.getTime() || time.getTime() > maxTime.getTime()) {
                return true;
              }

              return false;
            };
          }

          // 当两个日期都选完时，恢复到只有条件1的限制
          if (minDate && maxDate) {
            this.pickerOptions.disabledDate = (time) => {
              const sixMonthsAgoTime = getSixMonthsAgo();
              return time.getTime() < sixMonthsAgoTime;
            };
          }
        }
      }
    };
  },
  watch: {
    'queryForm.invoiceIssueTime'(val) {
      if (!val || val.length === 0) {
        const sixMonthsAgoTime = new Date();
        sixMonthsAgoTime.setMonth(sixMonthsAgoTime.getMonth() - 6);
        sixMonthsAgoTime.setHours(0, 0, 0, 0);

        this.pickerOptions.disabledDate = (time) => {
          return time.getTime() < sixMonthsAgoTime.getTime();
        };
      }
    },
    showExportByCustomer: {
      handler(val) {
        this.showExportByCustomerWindow = val;
        if (this.$refs.exportCustomerRef) {
          this.$refs.exportCustomerRef.resetFields();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取客户选项
    getCustomerPage(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param, false).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 打开客户选项弹窗
    changeCustomerPage(val) {
      if (val) {
        this.getCustomerPage();
      }
    },
    // 关闭弹窗
    closeWindow() {
      this.$emit('closeWindow', false);
      this.showExportByCustomerWindow = false;
    },
    // 按客户导出
    clickExportByCustomer() {
      this.$refs.exportCustomerRef.validate((valid) => {
        if (valid) {
          const param = {
            customerIds: [this.queryForm.customerId],
            startInvoiceTime: this.queryForm.invoiceIssueTime[0],
            endInvoiceTime: this.queryForm.invoiceIssueTime[1]
          };
          exportCteInvoiceByCustomer(param).then(() => {
            goResourceTaskList().finally(() => {
              this.closeWindow();
            });
          }).catch(err => {
            console.error(err);
          });
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
